import { render, staticRenderFns } from "./InsuranceBase.vue?vue&type=template&id=637b713d"
import script from "./InsuranceBase.vue?vue&type=script&lang=js"
export * from "./InsuranceBase.vue?vue&type=script&lang=js"
import style0 from "./InsuranceBase.vue?vue&type=style&index=0&id=637b713d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports